import clsx from 'clsx';
import { ServerProduct } from '@/lib/janitsjar/Product';

export type SizePropertiesProps = {
  product?: ServerProduct;
};

export function SizeProperties({ product }: SizePropertiesProps) {
  if (!product || !product.dimensions) return null;

  return (
    <ul className={clsx('print:flex')}>
      {Object.entries(product.dimensions).map(
        ([key, { label, value, unit }]) => {
          return (
            <li
              key={key}
              className={clsx(
                'text-left',
                'cap-xs',
                'pr-5 pb-1',
                'font-normal',
                'print:cap-sm',
                'print:font-semibold'
              )}
            >
              <span className={clsx('mr-2 print:block print:body-xs')}>
                {label}
              </span>
              {value} {unit}
            </li>
          );
        }
      )}
    </ul>
  );
}

export default SizeProperties;
